/**
 * RAKNIDA · rk-motion.js
 * Single IntersectionObserver for [data-rk-m] scroll reveals.
 * Skips Shopify design mode and prefers-reduced-motion.
 */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isDesignMode() {
    return (
      (window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode)) ||
      document.documentElement.classList.contains('shopify-design-mode') ||
      !!(document.body && document.body.classList.contains('shopify-design-mode'))
    );
  }

  function revealAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-rk-m]').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function indexStagger(root) {
    (root || document).querySelectorAll('[data-rk-stagger]').forEach(function (parent) {
      var kids = parent.querySelectorAll(':scope > [data-rk-m]');
      kids.forEach(function (el, i) {
        el.style.setProperty('--rk-m-i', String(i));
      });
    });
  }

  function unlockHero(root) {
    var scope = root || document;
    scope.querySelectorAll('.rk-hero[data-rk-hero-wait]').forEach(function (hero) {
      hero.classList.add('rk-hero--ready');
    });
  }

  function onPreloaderDone(cb) {
    if (isDesignMode() || document.documentElement.classList.contains('rk-preloader-done')) {
      cb();
      return;
    }
    var pre = document.getElementById('rk-preloader');
    if (!pre) {
      cb();
      return;
    }
    if (pre.classList.contains('is-done') || !pre.isConnected) {
      cb();
      return;
    }
    var done = false;
    function fire() {
      if (done) return;
      done = true;
      cb();
    }
    document.addEventListener('rk:preloader:done', fire, { once: true });
    var obs = new MutationObserver(function () {
      if (pre.classList.contains('is-done')) {
        obs.disconnect();
        window.setTimeout(fire, 80);
      }
    });
    obs.observe(pre, { attributes: true, attributeFilter: ['class'] });
    window.setTimeout(fire, 4000);
  }

  function initObserver() {
    var DESIGN = isDesignMode();
    indexStagger(document);

    var io = null;
    if (!(REDUCE || DESIGN) && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      document.querySelectorAll('[data-rk-m]').forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealAll(document);
      unlockHero();
    }

    // Section re-renders in theme editor (setting toggles / overrides)
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      indexStagger(root);
      unlockHero(root);
      if (isDesignMode() || REDUCE || !io) {
        revealAll(root);
        return;
      }
      root.querySelectorAll('[data-rk-m]').forEach(function (el) {
        if (!el.classList.contains('is-in')) io.observe(el);
      });
    });
    document.addEventListener('shopify:section:select', function () {
      unlockHero();
      revealAll(document);
    });
  }

  function boot() {
    onPreloaderDone(function () {
      document.documentElement.classList.add('rk-preloader-done');
      unlockHero();
      initObserver();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
